







































































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  PropType,
  defineAsyncComponent,
} from '@vue/composition-api';
import { ubtSendError, ubtPage } from '@/shared/utils/ubt';
import { RouterV2Enum } from '@/router/router-names';
import type { QueryContractListResponse, ProductItemType } from '@/api/rights/shop-mall/types';
import ForceReadBtn, { ButtonTypeEnum } from '@/components/force-read-btn';
import store from '@/store';
import { getDcContractList } from '@/api/contract';
import type { Commodity } from '@/api/contract/types';
import { creditMallApply } from '@/api/rights/shop-mall';
import { CreditMallFromEnum } from '@/api/rights/shop-mall/types';
import { dcCreditSceneEnum } from '@/api/preApplyChoose/types';
import { VerifySceneEnum, OpenVerifyPageMode } from '@/shared/verify-credit-controller/types';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import SuperMemberCard from '@/widgets/right-buy-card/super-member-card/entry';
import { SuperMemberSourceEnum, SuperMemberSceneEnum } from '@/api/rights/types';
import '@/views_v2/pre-apply-choose/store';
import FqMall from './compoments/fqMall.vue';
import UnitAgreementControlGroup from './compoments/unit.vue';
import {
  newUbtPageButton, newUbtModuleExpose, shopMallAgreementExpose, shopMallAgreementClick,
  retentionDialogExpose, retentionDialogConfirmClick,
} from './tianqi';


export default defineComponent({
  name: 'UnitAgreement',
  components: {
    ForceReadBtn,
    FqMall,
    UnitAgreementControlGroup,
    RetentionDialog: defineAsyncComponent(() => import('./compoments/retention-dialog.vue')),
  },
  props: {
    showLoading: {
      type: Boolean,
      default: false,
    },
    productList: {
      type: Array as PropType<ProductItemType[]>,
      default: () => [],
    },
    /** 分期商城协议列表 */
    fqMallContractList: {
      type: Object as PropType<QueryContractListResponse>,
      default: () => ({}),
    },
    dcCreditScene: {
      type: String as PropType<dcCreditSceneEnum>,
      default: dcCreditSceneEnum.NO_CHANNEL_AVAILABLE,
    },
    /** 投放来源 */
    from: {
      type: String,
      default: '',
    },
  },
  emits: [
    'loadAgreements',
  ],
  setup(props: {
    fqMallContractList: QueryContractListResponse,
    dcCreditScene: dcCreditSceneEnum,
    productList: ProductItemType[],
    showLoading: boolean,
    from: string,
  }, context: any) {
    const router = context.root.$router;
    const dcCommodityList = ref<Commodity[]>([]);

    /** 是否贷超半流程 */
    const isDcHalfApply = computed(() => store.state.preApplyChoose.isDcHalfApply);
    /** 流量分发数据 */
    const applyChooseList = computed(() => store.state.preApplyChoose.applyChooseList);
    /** 流量分发渠道相关数据 */
    const commodities = computed(() => applyChooseList.value?.commoditys || []);
    const applyMode = computed(() => applyChooseList.value?.applyMode || '');
    /** 渠道列表 */
    const commodityIdList = computed(
      () => commodities.value.map((item) => item.commodityId),
    );

    const unitAgreementControlGroupRef = ref<InstanceType<typeof UnitAgreementControlGroup>>();

    /** 超级会员卡挂载节点 */
    const superMemberCardRef = ref<HTMLElement | null>(null);
    /** 超级会员卡所需商品 ID 列表（来自分期商城 productList） */
    const superMemberCardCommodityIds = computed(
      () => props.productList.map((p) => Number(p.productId)),
    );
    const hasSuperMemberCard = ref(false);

    /** 是否显示挽留弹窗 */
    const showRetentionDialog = ref(false);

    /** 是否已显示过挽留弹窗（防止重复显示） */
    const hasShownRetentionDialog = ref(false);

    /** 是否需要弹出资料补充页弹窗（用于需要补充资料流程） */
    const needShowVerifyCreditPopup = ref(false);

    /** 授信单号 */
    const currentCreditTaskId = ref('');

    /** 投放来源：授信来源 */
    const from = computed(() => props.from || CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT);

    /**
     * 获取贷超半流程协议并进行一一匹配
     */
    const getDcContracts = async () => {
      try {
        if (!commodityIdList.value.length) {
          return;
        }
        const data = await getDcContractList(commodityIdList.value);

        // 进行一一匹配：将 commodities 和 data 进行匹配
        dcCommodityList.value = commodities.value.reduce((acc, item) => {
          // 根据 commodityId 和 productId 进行匹配
          const agreement = data.find(
            (info) => Number(info.productId) === Number(item.commodityId),
          );

          // 如果匹配到协议且协议列表不为空，则添加到结果中
          if (agreement && agreement.contractList?.length) {
            // 合并数据：保留 item 中的名称和图标，使用 agreement 中的协议列表
            acc.push({
              ...agreement,
              productId: String(item.commodityId),
              productName: item.commodityName || agreement.productName || '',
              productIcon: item?.icon || agreement?.productIcon || '',
            });
          }

          return acc;
        }, [] as Commodity[]);
      } catch {
        ubtSendError('getDcContracts error');
      }

      context.emit('loadAgreements');
    };

    /** 是否同时存在分期商城协议和贷超半流程协议 */
    const hasBothContracts = computed(() => props.fqMallContractList?.contractList?.length > 0
    && dcCommodityList.value.length > 0);

    /** 是否只有分期商城协议 */
    const hasOnlyFqMallContracts = computed(() => props.fqMallContractList?.contractList?.length > 0
    && dcCommodityList.value.length === 0);

    /** 倒计时点击 */
    const onCountDown = () => {
      newUbtPageButton(shopMallAgreementClick, {
        buttonName: '倒计时期间点击',
        from: from.value,
      });
    };

    /**
     * 提交按钮点击
     */
    const onSubmit = async () => {
      newUbtPageButton(shopMallAgreementClick, {
        buttonName: '提交按钮点击',
        from: from.value,
      });

      /** 是否检查贷超半流程协议 */
      const isCheckDcContracts = unitAgreementControlGroupRef.value?.isCheckboxChecked;

      /** 跳转参数组装 */
      const query: Dictionary<string | boolean | undefined> = {
        isCheckDcContracts: String(isCheckDcContracts || false),
        from: from.value,
      };

      if (isCheckDcContracts && commodityIdList.value.length) {
        query.dcIdList = String(commodityIdList.value.join(','));
      }
      if (isCheckDcContracts && props.dcCreditScene) {
        query.dcCreditScene = props.dcCreditScene;
      }
      if (isCheckDcContracts && applyChooseList.value?.applyMode) {
        query.applyMode = applyChooseList.value.applyMode;
      }

      /**
       * 跳转到等待页
       */
      const jumpToWaitingPage = (
        creditTaskId: string,
        queryParams: Dictionary<string | boolean | undefined>,
      ) => {
        router.replace({
          path: RouterV2Enum.unitWaitingPage,
          query: {
            creditTaskId,
            ...queryParams,
          },
        });
      };

      /**
       * 授信成功后检查是否需购买超级会员并预下单（与 pre-apply-choose 主流程一致）
       */
      const checkSatusAndBuyRight = async (taskId: string) => {
        const needBuy = SuperMemberCard.needBuySuperMemberCard();
        if (needBuy && taskId) {
          try {
            await SuperMemberCard.buyRights(taskId);
          } catch (err) {
            ubtSendError(err instanceof Error ? err : new Error(String(err)));
          }
        }
      };

      /**
       * 跳转到失败页
       */
      const jumpToFailedPage = (errorMessage: string) => {
        jumpToNewVersion(NewVersionEnum.HALF_PROCESS_FAILED, true);
        ubtSendError(errorMessage);
      };

      /**
       * 显示挽留弹窗
       */
      const showRetentionDialogIfNeeded = (options?: {
        needShowVerifyCreditPopup?: boolean;
      }): boolean => {
        // 如果未勾选贷超协议且有贷超协议且未显示过挽留弹窗，则显示
        if (!isCheckDcContracts && hasBothContracts.value && !hasShownRetentionDialog.value) {
          // 标记已显示过挽留弹窗，防止重复显示
          hasShownRetentionDialog.value = true;
          showRetentionDialog.value = true;

          // 如果需要弹出资料补充页，设置标记
          if (options?.needShowVerifyCreditPopup) {
            needShowVerifyCreditPopup.value = true;
          }

          // 挽留弹窗曝光埋点
          newUbtModuleExpose(retentionDialogExpose, {
            from: from.value,
          });

          return true;
        }
        return false;
      };

      /**
       * 检查贷超协议并处理挽留弹窗或跳转
       */
      const checkDcContractAndHandle = async (
        creditTaskId: string,
        queryParams: Dictionary<string | boolean | undefined>,
      ) => {
        // 如果显示了挽留弹窗，则不执行后续跳转
        if (showRetentionDialogIfNeeded()) {
          return;
        }
        // 超级会员购买预下单（与 consent-agreement 流程一致）
        await checkSatusAndBuyRight(creditTaskId);
        jumpToWaitingPage(creditTaskId, queryParams);
      };

      /**
       * 处理贷超流程或失败页跳转
       */
      const handleDcOrFailed = (errorMessage: string) => {
        // 如果显示了挽留弹窗，则不执行后续跳转
        if (showRetentionDialogIfNeeded()) {
          return;
        }
        if (isDcHalfApply.value && isCheckDcContracts) {
          // 贷超流程没有授信单号
          jumpToWaitingPage('', query);
        } else {
          jumpToFailedPage(errorMessage);
        }
      };

      /**
       * 跳转到资料补充页
       */
      const jumpToVerifyCreditPage = () => {
        const applyProductIds = props.productList.map((item) => item.productId);
        jumpToVerifyCredit(VerifySceneEnum.PRE_CREDIT_FQ_SHOPPING, {
          openMode: OpenVerifyPageMode.POPUP_SHOW,
          successCb: async () => {
            try {
              const res = await creditMallApply({
                productIds: applyProductIds,
                from: CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
              });
              if (res?.creditTaskId) {
                // 检查贷超协议并处理挽留弹窗或跳转
                await checkDcContractAndHandle(res.creditTaskId, query);
              }
            } catch (err) {
              // handleDcOrFailed('creditMallApply error');
            }
          },
        });
      };

      // 如果需要弹出资料补充页，直接弹出资料补充页
      if (needShowVerifyCreditPopup.value) {
        needShowVerifyCreditPopup.value = false;
        jumpToVerifyCreditPage();
        return;
      }

      const applyProductIds = props.productList.map((item) => item.productId);

      /** 如果分期商城协议列表不为空，则申请授信 */
      if (props.fqMallContractList?.contractList?.length > 0 && !!props.productList.length) {
        try {
          /** 未申请过授信，则申请授信 */
          if (!currentCreditTaskId.value) {
            const result = await creditMallApply({
              from: CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
              productIds: applyProductIds,
            });
            if (result?.creditTaskId) {
              currentCreditTaskId.value = result.creditTaskId;
            }
          }
          // 如果申请授信成功
          if (currentCreditTaskId.value) {
            // 检查贷超协议并处理挽留弹窗或跳转
            await checkDcContractAndHandle(currentCreditTaskId.value, query);
          }
        } catch (error) {
          // 如果申请授信失败并且错误码为300002，需要补充资料
          if ((error as Dictionary).code === 300002) {
            // 先检查是否需要显示挽留弹窗
            if (showRetentionDialogIfNeeded({ needShowVerifyCreditPopup: true })) {
              return;
            }
            // 弹出资料补充页
            jumpToVerifyCreditPage();
          } else {
            // 其他错误，根据是否勾选贷超协议决定跳转
            handleDcOrFailed('creditMallApply error');
          }
        }
      } else {
        // 如果没有分期商城协议，根据是否勾选贷超协议决定跳转
        handleDcOrFailed('no fq mall contract list error');
      }
    };

    /**
     * 挽留弹窗关闭（右上角关闭）
     */
    const onRetentionDialogClose = () => {
      showRetentionDialog.value = false;
      onSubmit();
    };

    /**
     * 挽留弹窗确认（同意协议）
     */
    const onRetentionDialogConfirm = () => {
      // 挽留弹窗确认按钮点击埋点
      newUbtPageButton(retentionDialogConfirmClick, {
        from: from.value,
      });
      showRetentionDialog.value = false;
      // 勾选贷超协议
      if (unitAgreementControlGroupRef.value?.changeCheckbox) {
        unitAgreementControlGroupRef.value.changeCheckbox();
      }
      // 清空待跳转参数和资料补充页标记
      needShowVerifyCreditPopup.value = false;
    };

    /** 初始化超级会员卡（挂载在 buttonArea 内，productIds 与 sceneType 二选一必填） */
    const initSuperMemberCard = async () => {
      // 分期商城 & 贷超都存在的场景，不去分发，避免影响实验
      if (hasOnlyFqMallContracts.value) {
        await nextTick();
        const el = superMemberCardRef.value;
        if (!el) return;
        try {
          await SuperMemberCard.init(
            {
              productIds: props.productList.map((item) => Number(item.productId)),
              // productList: props.productList.map((item) => Number(item.productId)),
              sceneType: SuperMemberSceneEnum.FQ_MALL_AGREEMENT_SCENE,
              from: 'finance_shopMall_agreement' as SuperMemberSourceEnum,
            },
            el,
          );
          hasSuperMemberCard.value = SuperMemberCard.getSuperMember().isSuperMemberCardShow;
        } catch {
        // 初始化失败不阻塞协议页
        }
      }
    };

    onMounted(async () => {
      ubtPage('finance_loan_shopMall_agreement', '', Date.now(), undefined, {
        from: from.value,
      });

      newUbtModuleExpose(shopMallAgreementExpose, {
        supplierCode: props.fqMallContractList?.contractFromList?.join(',') || '',
        from: from.value,
      });
      /**
       * 如果是贷超半流程，且有渠道，则获取协议
       * 是贷超半流程不等同于有渠道，加强判断
       */
      if (isDcHalfApply.value && commodityIdList.value?.length > 0) {
        await getDcContracts();
      } else {
        context.emit('loadAgreements');
      }
      await initSuperMemberCard();
    });

    onBeforeUnmount(() => {
      SuperMemberCard.destroyInstance();
    });

    return {
      from,
      hasBothContracts,
      hasOnlyFqMallContracts,
      hasSuperMemberCard,
      contractList: props.fqMallContractList?.contractList || [],
      unitAgreementControlGroupRef,
      superMemberCardRef,
      superMemberCardCommodityIds,
      dcCommodityList,
      applyMode,
      showRetentionDialog,
      onCountDown,
      onSubmit,
      onRetentionDialogClose,
      onRetentionDialogConfirm,
      ButtonTypeEnum,
    };
  },
});
